module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "maintenance-wrapper"
  }, [_c('img', {
    staticClass: "docer-image",
    attrs: {
      "src": require("../../assets/images/docer.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "maintenance-content"
  }, [_vm._v("Docer is under maintenance, come back later...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a1148a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/v2/templates/Maintenance.vue
// module id = 104
// module chunks = 1